<template>
    <div class="d-flex align-center" @click.stop.prevent="">
        <router-link
            v-if="item"
            :to="{ name: 'client_profile', params: { id: item.client_id }}"
            style="text-decoration: none"
        >
            <AccountAvatar
                :inverted="item.status === 'finished'"
                :color="item.client ? item.client.color : item.color"
                :initials="item.client ? item.client.client_initials : item.client_initials"
                :size="dense ? 31 : 21"
                :text-class="dense ? 'font-weight-bold' : 'font-weight-medium'"
                tile
                :class="$vuetify.breakpoint.smAndDown ? '' : ''"
            />
        </router-link>
        <OverflowTooltipText
            v-if="item.client"
            :title="item.client.name"
        />
    </div>
</template>

<script>
import AccountAvatar from "@/components/AccountAvatar";
import OverflowTooltipText from "@/components/RichDataTable/components/OverflowTooltipText";

export default {

    name: "RichDataTableClientAvatar",
    components: {
        AccountAvatar,
        OverflowTooltipText
    },
    props: {
        item: {
            type: Object,
            default: null
        },
        dense: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {

        return {
        };
    }
};
</script>
